export const PageWrapper = ({children}) => {
    return children
}